import moment from 'moment';
import 'moment/locale/de';
moment.locale('de');

function formatDate({
  date,
  endDate,
  startDate,
  prefix,
  fallback = 'Kein Datum gefunden',
}) {
  // this function prefixes the date with a string
  function prepend(value) {
    return prefix ? `${prefix} ${value}` : value;
  }
  const completeFormat = 'DD.MM.YYYY';
  if (!date && !startDate) return prepend(fallback);
  // if we only have a 'date', return it formatted
  if (date && !startDate)
    return prepend(`${moment(date).format(completeFormat)}`);
  // if we startDate and but no endDate
  if (!endDate) return prepend(moment(startDate).format(completeFormat));

  const startMoment = moment(startDate);
  const endMoment = moment(endDate);

  const start = {
    date: startMoment.format(completeFormat),
    day: startMoment.format('DD'),
    month: startMoment.format('MM'),
    year: startMoment.format('YYYY'),
  };
  const end = {
    date: endMoment.format(completeFormat),
    day: endMoment.format('DD'),
    month: endMoment.format('MM'),
    year: endMoment.format('YYYY'),
  };

  // return formatted date
  if (start.date === end.date) return prepend(start.date); // if its the same day
  if (start.year !== end.year) return prepend(`${start.date} - ${end.date}`); // if the years are different
  if (start.month !== end.month)
    return prepend(`${start.day}.${start.month}. - ${end.date}`); // if the months are different
  return prepend(`${start.day}. - ${end.date}`); // ONLY if the days are different
}

export default formatDate;
